import styled from 'styled-components'
import { orange } from 'src/styles/colors'

export const BoxPdf = styled.div`
  border: solid 1px ${orange.light};
  border-radius: 8px;
`
